/* live_v2/persistence.js — per-sport preset preference (localStorage).
 *
 * Post-cleanup Phase B (Xav 2026-05-31): this module's old
 * layout-save / fetch-merged / cached-layout machinery is gone. Layouts
 * are loaded from /api/system-presets (system) or /api/user-dashboards
 * (user), and saved via PUT /api/user-dashboards/{id} from
 * live_v2/index.js#_saveSoon. All that remains here is the
 * single-key preset preference store, which is independent of layout
 * persistence and survives across the rebuild.
 *
 * localStorage key:
 *   ls.dash_preset.v1:<uid>:<sport_id>
 */

window.LSLayoutStore = {
  /** Per-sport preset preference — which system preset (simple /
   *  analytical) the user last picked for this sport. Read on init
   *  by _resolveInitialPreset; written on switchPreset. */
  _prefKey(uid, sport_id) {
    return `ls.dash_preset.v1:${uid || 'anon'}:${(sport_id || '').toLowerCase()}`;
  },
  readPreference(uid, sport_id) {
    try { return localStorage.getItem(this._prefKey(uid, sport_id)); }
    catch (_) { return null; }
  },
  writePreference(uid, sport_id, preset_id) {
    try { localStorage.setItem(this._prefKey(uid, sport_id), preset_id); }
    catch (_) {}
  },
};
